import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Projects from './components/Projects';
import AIAutomation from './components/AIAutomation';
import Education from './components/Education';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Chatbot from './components/Chatbot';
import HiddenChat from './components/HiddenChat';
import './styles/globals.scss';

function App() {
  const [currentSection, setCurrentSection] = useState('home');
  const [showHiddenChat, setShowHiddenChat] = useState(false);
  const [keySequence, setKeySequence] = useState('');

  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      const updatedSequence = keySequence + e.key;
      setKeySequence(updatedSequence);

      // Secret combination: type "chat" to show the hidden chat
      if (updatedSequence.includes('chat')) {
        setShowHiddenChat(true);
        setKeySequence('');
      }

      // Reset sequence after 2 seconds of no input
      setTimeout(() => setKeySequence(''), 2000);
    };

    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && showHiddenChat) {
        setShowHiddenChat(false);
      }
    };

    window.addEventListener('keypress', handleKeyPress);
    window.addEventListener('keydown', handleEscape);

    return () => {
      window.removeEventListener('keypress', handleKeyPress);
      window.removeEventListener('keydown', handleEscape);
    };
  }, [keySequence, showHiddenChat]);

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'about', 'experience', 'skills', 'projects', 'ai-automation', 'education', 'contact'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setCurrentSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App">
      <Header currentSection={currentSection} />
      <main>
        <Hero />
        <About />
        <Experience />
        <Skills />
        <Projects />
        <AIAutomation />
        <Education />
        <Contact />
      </main>
      <Footer />
      <Chatbot />
      {showHiddenChat && <HiddenChat />}
    </div>
  );
}

export default App;
